import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import { renderMarkdownSafe } from '@/utils/md-to-html/md-to-html';
import { highlightHtml } from '@/utils/searchHighlight';
import styles from './MDXContentPreview.module.scss';

const cx = classNames.bind(styles);

interface MDXContentPreviewProps {
  content: string;
  searchQuery?: string;
}


const MDXContentPreview: React.FC<MDXContentPreviewProps> = ({ content, searchQuery }) => {
  // Cache the rendered HTML to avoid re-processing on every render
  const renderedHTML = useMemo(() => {
    // Truncate content to max 1000 characters or 20 lines (whichever comes first)
    const truncateContent = (text: string): string => {
      const lines = text.split('\n');
      const first20Lines = lines.slice(0, 20).join('\n');

      // Use whichever is shorter: first 20 lines or 1000 characters
      if (first20Lines.length <= 1000) {
        return first20Lines;
      }

      return text.substring(0, 1000);
    };

    const truncatedContent = truncateContent(content);
    return highlightHtml(renderMarkdownSafe(truncatedContent), searchQuery);
  }, [content, searchQuery]);

  return (
    <div
      className={cx('container')}
      dangerouslySetInnerHTML={{ __html: renderedHTML }}
    />
  );
};

export default MDXContentPreview;
